import tw from 'twin.macro';

export const SectionContainer = tw.div`py-24 sm:py-28`;

export const GridContainer = tw.div`grid grid-cols-1 md:grid-cols-2 gap-6 mx-auto max-w-7xl px-6 lg:px-8`;

export const NeighborCard = tw.div` bg-white max-w-xl flex-1 basis-1/3`;

export const ImageCardContainer = tw.div`relative`;

export const NeighborImage = tw.img`w-full h-96 object-cover`;

export const NeighborLink = tw.a`no-underline text-black font-bold hover:underline`;

export const Heading = tw.p`font-semibold text-lg uppercase text-left border-l px-3 py-8 mx-5 border-gray-900`;
